"use client"

import Typewriter from "typewriter-effect"

/** Set to true when the newsletter block below should be shown again. */
const SHOW_NEWSLETTER = false

const Hero5 = () => {
	return (
		<>
			<div className="banner">
				<div className="row justify-content-center">
					<div className="col-xl-8 col-lg-10 text-center pt-100 pb-50">
						<span className="text-sm-bold color-gray-600 wow animate__animated animate__fadeInUp d-inline-block">
							About me
						</span>
						<h1 className="color-gray-50 wow animate__animated animate__fadeInUp mb-20 mt-20 d-flex flex-wrap justify-content-center align-items-baseline gap-x-2 gap-y-2">
							I'm
							<Typewriter
								options={{
									wrapperClassName: "typewrite color-linear",
									strings: ["Konrad", "DevOps", "Network En."],
									autoStart: true,
									loop: true,
								}}
							/>
						</h1>
						<p className="color-gray-600 wow animate__animated animate__fadeInUp text-base mx-auto max-w-2xl">
							Notes and tutorials from my day job and homelab—Linux hosting, networking,
							and the tools that keep systems running.
						</p>
						{SHOW_NEWSLETTER && (
							<div className="box-subscriber mb-50 wow animate__animated animate__fadeInUp mt-40">
								<div className="inner-subscriber bg-gray-800">
									<form className="d-flex" action="#">
										<input
											className="input-sybscriber"
											type="text"
											placeholder="Type your email address"
										/>
										<button className="btn btn-linear btn-arrow-right" type="button">
											Join me
											<i className="fi-rr-arrow-small-right" />
										</button>
									</form>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</>
	)
}

export default Hero5
